document.addEventListener('DOMContentLoaded', function() {
  const productData = window.productData || {};
  const availableInventory = productData.available || 0;
  
  if (availableInventory === 0) {
    const pickupElements = document.querySelectorAll('[data-pickup-availability], .pickup-availability, [class*="pickup"]');
    pickupElements.forEach(element => {
      element.style.display = 'none';
    });
  }
});